export default {"src":"/_next/static/media/AvatarFallback.8712fc5c.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};